"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineOfCoverageEditorOptions = void 0;
var react_1 = require("react");
var definitions_1 = require("../../../hooks/definitions");
var use_fuzzy_1 = require("../../../utils/hooks/use-fuzzy");
function filterLinesOfCoverage(selectedPolicyType, policyTypeDefinitions, excludedLineOfCoverageTypes, allLineOfCoverageTypes) {
    var _a, _b;
    /**
     * Start with all lines of coverage types
     */
    var filteredLineOfCoverageTypes = allLineOfCoverageTypes;
    /**
     * If a policy type is selected, set to the line of coverage types (locs) from the policy type definition.
     * If there are no locs on the policy type definition, set to an empty array []
     */
    if (selectedPolicyType) {
        filteredLineOfCoverageTypes = (_b = (_a = policyTypeDefinitions[selectedPolicyType]) === null || _a === void 0 ? void 0 : _a.locs) !== null && _b !== void 0 ? _b : [];
    }
    if (excludedLineOfCoverageTypes && excludedLineOfCoverageTypes.length > 0) {
        var excludedLinesOfCoverage_1 = new Set(excludedLineOfCoverageTypes);
        filteredLineOfCoverageTypes = filteredLineOfCoverageTypes.filter(function (type) { return !excludedLinesOfCoverage_1.has(type); });
    }
    return filteredLineOfCoverageTypes;
}
function useLineOfCoverageEditorOptions(_a) {
    var onSelect = _a.onSelect, program = _a.program, _b = _a.excludedLineOfCoverageTypes, excludedLineOfCoverageTypes = _b === void 0 ? [] : _b;
    var _c = definitions_1.useDefinitionsHelpers({
        program: program,
    }), lineOfCoverageTypes = _c.lineOfCoverageTypes, lineOfCoverageTypeDefinitions = _c.lineOfCoverageTypeDefinitions, renderLineOfCoverageType = _c.renderLineOfCoverageType, policyTypeDefinitions = _c.policyTypeDefinitions;
    // Selected policy type to filter by
    var _d = react_1.useState(), selectedPolicyType = _d[0], setSelectedPolicyType = _d[1];
    var lineOfCoverageTypeDetails = react_1.useMemo(function () {
        var filteredLineOfCoverageTypes = filterLinesOfCoverage(selectedPolicyType, policyTypeDefinitions, excludedLineOfCoverageTypes, lineOfCoverageTypes);
        // Enrich each line of coverage type with version number and null displayName
        return enrichLineOfCoverageType(filteredLineOfCoverageTypes, lineOfCoverageTypeDefinitions);
    }, [
        lineOfCoverageTypes,
        selectedPolicyType,
        excludedLineOfCoverageTypes,
        lineOfCoverageTypeDefinitions,
        policyTypeDefinitions,
    ]);
    // Line of coverage MenuItems
    var menuItems = react_1.useMemo(function () {
        return lineOfCoverageTypeDetails.map(function (loc) { return ({
            label: renderLineOfCoverageType(loc.type),
            onClick: function () {
                onSelect(loc);
            },
        }); });
    }, [lineOfCoverageTypeDetails, renderLineOfCoverageType, onSelect]);
    // Search MenuItems by label
    var _e = use_fuzzy_1.useFuzzy(menuItems, {
        keys: ['label'],
    }), lineOfCoverageOptions = _e.result, keyword = _e.keyword, search = _e.search;
    return {
        selectedPolicyType: selectedPolicyType,
        setSelectedPolicyType: setSelectedPolicyType,
        lineOfCoverageOptions: lineOfCoverageOptions,
        keyword: keyword,
        search: search,
    };
}
exports.useLineOfCoverageEditorOptions = useLineOfCoverageEditorOptions;
/**
 * For each LineOfCoverageType in given array, enrich LineOfCoverageType with version number and null displayName
 * Returns array of LineOfCoverageTypeDetails
 * @param types array of LineOfCoverageTypes to enrich
 * @param definitions map of LineOfCoverageType to it's definition
 */
function enrichLineOfCoverageType(types, definitions) {
    var locDefinitions = types.map(function (type) { return definitions[type] || []; });
    return locDefinitions.map(function (loc) { return ({
        type: loc.id,
        version: loc.currentVersion,
        displayName: null,
    }); });
}
